import { reducerFactory } from '../../common/helpers/reducerHelpers';

export const FETCH_VBQL_RESULT = 'FETCH_VBQL_RESULT';

export default reducerFactory('vbqlResults', {
  [FETCH_VBQL_RESULT]: (state, action) => ({
    ...state,
    projectionKeys: [...new Set([...state.projectionKeys, action.payload.projectionKeys])],
    [action.payload.projectionKey]: {
      ...state[action.payload.projectionKey],
      query: action.payload.query,
      isLoading: true,
    },
  }),
});
